type GuardrailUserRole = "patient navigator" | "referrer" | "patient";

/**
 * Patient Navigators are allowed to bypass age/screener guardrails that
 * would otherwise route patients to Contact Us.
 */
export const canRoleBypassGuardrails = (userRole?: GuardrailUserRole): boolean => {
  return normalizeRole(userRole) === "patient navigator";
};

function normalizeRole(role?: GuardrailUserRole | string): string {
  return (role ?? "")
    .trim()
    .toLowerCase()
    .replace(/[-_\s]+/g, " ");
}

export const canRoleOverrideInsuranceExclusion = (
  userRole?: GuardrailUserRole,
  rolesAllowedToOverride?: string[] | null,
): boolean => {
  if (!userRole || !Array.isArray(rolesAllowedToOverride) || rolesAllowedToOverride.length === 0) {
    return false;
  }

  return rolesAllowedToOverride.some((role) => {
    return normalizeRole(role) === normalizeRole(userRole);
  });
};
